import { SVGIconComponent } from './types';

export const StatusUndoCancel: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-uncancel" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M14,12 C11.2384299,12 9,14.2384299 9,17 C9,19.7611686 11.2384299,22 14,22 C16.7611686,22 19,19.7611686 19,17 C19,14.2384299 16.7611686,12 14,12 Z M15.8858548,18.9054312 C15.6862464,19.1050397 15.3627246,19.1050397 15.1635077,18.9054312 L14.0258709,17.7677944 L12.8364321,18.9572332 C12.6368236,19.1568417 12.3133019,19.1568417 12.1140849,18.9572332 C11.9144765,18.7576247 11.9144765,18.434103 12.1140849,18.2344945 L13.3035237,17.0450557 L12.1961048,15.9376368 C11.9964963,15.7380283 11.9964963,15.4145066 12.1961048,15.2148981 C12.3957133,15.0152896 12.719235,15.0152896 12.9188435,15.2148981 L14.0262624,16.322317 L15.0819797,15.2665997 C15.2815882,15.0669913 15.6051099,15.0669913 15.8043269,15.2665997 C16.0039353,15.4662082 16.0039353,15.7897299 15.8043269,15.9893384 L14.7486096,17.0450557 L15.8862464,18.1826925 C16.0854633,18.382301 16.0854633,18.7058227 15.8858542,18.9054312 L15.8858548,18.9054312 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M15,12.9059737 C15,11.2401716 14.3682165,9.64180469 13.2423153,8.46378236 C12.1173892,7.28473907 10.5912393,6.62313555 9.00034373,6.62313555 L6.41577584,6.62313555 L9.41557898,3.48174267 L8.00062183,2 L3.29393071,6.92989257 C3.10546558,7.12622962 3,7.39209617 3,7.67024034 C3,7.9483845 3.10546308,8.21425105 3.29393071,8.4105881 L8.00062183,13.3404807 L9.41557898,11.858738 L6.41577584,8.71734512 L9.00034373,8.71734512 C10.0608241,8.71734512 11.0783324,9.15910349 11.8281582,9.94445172 C12.5779839,10.7297999 12.9999563,11.7953342 12.9999563,12.9057381 L12.9999563,15 L14.999825,15 L15,12.9059737 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
